import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setCardNameInputSchema = z.object({
  newName: z.string().describe('The new name of the card'),
});

export default function setCardNameTool() {
  async function execute(
    params: ToolExecuteParams<typeof setCardNameInputSchema, BaseCardScratchpadState>,
  ) {
    const {newName} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<BaseCardScratchpadState>(agentScratchpad);

    validatedScratchpad.card.name = newName.trim() || '';

    return toolResult(`Card name set successfully, new name: ${validatedScratchpad.card.name}`);
  }

  return tool<typeof setCardNameInputSchema, BaseCardScratchpadState>({
    name: V2CardAgentToolName.SetCardName,
    description: 'Set the name of the current card',
    displayName: 'Setting card name',
    inputSchema: setCardNameInputSchema,
    execute,
  });
}
